import script from "./MailPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./MailPreview.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__